import styled from 'styled-components';
import { paddings } from '~/styled';

export const SliderPageLegendWrapperDiv = styled.div`
  margin-top: ${paddings.medium2xPadding};

  &:not(:empty) {
    min-height: 95px;
  }
`;
export const ContentReadMoreBtnDiv = styled.div`
  margin-top: -${paddings.hugePadding};
  display: flex;
  justify-content: end;
  z-index: 2;

  & > button > div > span {
    text-transform: none;
  }

  & > button {
    background-color: transparent;
  }
`;

export const SliderPageLegendContentDiv = styled.div`
  margin-top: ${paddings.tinyPadding};
`;

export const ContentRowDiv = styled.div<{ $fadeOut: boolean }>`
  align-items: center;
  color: ${({ theme }) => theme.colors.onSurface};
  opacity: ${({ $fadeOut }) => ($fadeOut ? 0.4 : 1)};
`;
